import { proxy } from 'valtio'
import Homepage from './pages/Homepage'
import InfoPage from './pages/InfoPage'
import LetterPage from './pages/LetterPage'

function App() {
  return (
    <div className='App select-none '>
      <Homepage event='homepage' />
      <LetterPage event='letterPage' />
      <InfoPage event='infoPage' />
    </div>
  )
}

export default App
